import React from 'react';
import { DeviceType } from '../enum/EnumRepository';
import { useDeviceStore } from '../store/deviceStore';


interface MobileTabletConvertWrapperProps {
  onlyMobileChildren: React.ReactNode;
  onlyNotMobileChildren: React.ReactNode;
}

const MobileTabletConvertWrapper: React.FC<MobileTabletConvertWrapperProps> = ({ onlyMobileChildren, onlyNotMobileChildren }) => {
  const { deviceType } = useDeviceStore();

  return (
    <>
      {deviceType === DeviceType.MOBILE || deviceType === DeviceType.TABLET ? onlyMobileChildren : onlyNotMobileChildren}
    </>
  );
}



export default MobileTabletConvertWrapper;